export const UPDATE_CONTACT_START = 'UPDATE_CONTACT_START';

export const UPDATE_CONTACT_SUCCESS = 'UPDATE_CONTACT_SUCCESS';

export const UPDATE_CONTACT_FAILURE = 'UPDATE_CONTACT_FAILURE';
